/** #1299: Brendan accepted the NBA trader request on October 23, 2026:
 * Kalshi NBA GTS expires ten minutes after the listed start (:00 -> :10,
 * :30 -> :40). This is an expiry policy, not a changed game schedule or a
 * venue guarantee. Keep the offset here so a changed convention has one edit.
 * Pure shared policy: the browser imports this module; no relay dependencies.
 */
export const NBA_GTS_OFFSET_MS = 10 * 60_000;

export function kalshiGoodToStartMs(ticker: string, scheduledStartMs: number | null): number | null {
  if (scheduledStartMs == null || !Number.isFinite(scheduledStartMs) || scheduledStartMs <= 0) return null;
  return scheduledStartMs + (ticker.startsWith('KXNBA') ? NBA_GTS_OFFSET_MS : 0);
}
